// based on vc-align 2.4.5
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-align/index.js
// module id = 772
// module chunks = 0